import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import PartEncodeImg from './PartEncodeImg';
import PartDecodeImg from './PartDecodeImg';
import PartSVG from './PartSVG';

function App() {

  const [OpenCV, setOpenCV] = useState(null);

  useEffect(() => {
    console.log('useEffect')
    if (!window.cv) {
      const script = document.createElement("script")
      // script.src = "https://docs.opencv.org/4.5.2/opencv.js"
      script.src = process.env.PUBLIC_URL + '/libs/opencv.js'
      script.async = true
      script.addEventListener("load", async () => {
        let cv = window.cv;
        setOpenCV(cv)
        // console.log('cv', cv)
      });
      document.body.appendChild(script)
    }
  });

  return (

    <div className='container'>

      <main >
        <div className="container py-4">

          <header className="pb-3 mb-4 border-bottom">
            <a href="http://ckdroid.gitee.io/home/" className="d-flex align-items-center text-dark text-decoration-none">
              <img alt='hello' width="50" height="32" src={process.env.PUBLIC_URL + '/mount-fuji.svg'}></img>
              <span className="fs-4">主页</span>
            </a>
          </header>

          <div className="row align-items-md-stretch">

            <PartEncodeImg opencv={OpenCV} />

            <PartDecodeImg opencv={OpenCV} />

            <PartSVG />

          </div>

          <footer className="pt-3 mt-4 text-muted border-top text-center"  >
            <img alt='hello' style={{ marginTop: -10 }} width="30" height="24"
              src={process.env.PUBLIC_URL + '/mount-fuji.svg'}  ></img> &copy; 2021
          </footer>
        </div>

      </main>
    </div>


  )
}

export default App;
